<template>
  <div>
    <Slider maxHeight="150px" type="LoginPage" class="slider" />
    <CenteredContainer>
      <SfHeading class="sf-heading--left m-b-20" :level="2" :title="$t('Login')" />
      <form class="form" @submit.prevent="onSubmit">
        <SfInput
          v-model="email"
          name="email"
          label="E-mail"
          class="form__element"
          type="email"
          required
        />
        <SfInput
          v-model="password"
          name="password"
          :label="$t('Password')"
          type="password"
          class="form__element"
          :has-show-password="true"
          required
        />
        <SfButton type="submit" class="sf-button--full-width form__submit">
          {{ $t('Log In') }}
        </SfButton>
      </form>
      <SfButton @click="goToForgotPassword" class="sf-button--text action-button">
        {{ $t('Forgotten password?') }}
      </SfButton>
      <div class="aside">
        <SfHeading :title="$t(`Don't have an account yet?`)" :level="3" class="aside__heading" />
        <SfButton class="sf-button--text" @click="goToRegister">{{ $t('Register now') }}</SfButton>
      </div>
    </CenteredContainer>
  </div>
</template>
<script>
import { Base64 } from 'js-base64';
import { SfInput, SfButton, SfHeading } from '@storefront-ui/vue';
import { Slider } from '@/modules/core';
import CenteredContainer from '../components/CenteredContainer.vue';
import user from '../mixins/user';

export default {
  name: 'Login',
  mixins: [user],
  components: {
    SfInput,
    SfButton,
    SfHeading,
    CenteredContainer,
    Slider,
  },
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    goToForgotPassword() {
      this.$router.push('/forgot-password');
    },
    goToRegister() {
      this.$router.push('/register');
    },
    onSubmit() {
      const { email, password } = this;
      this.login({
        email,
        password: Base64.encode(password),
      }).then(() => {
        this.$router.push('/');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  width: 100%;
  &__element {
    margin: var(--spacer-base) 0;
  }
  &__checkbox {
    margin: var(--spacer-xl) 0 var(--spacer-2xl) 0;
  }
  &__submit {
    margin: var(--spacer-xl) 0 0 0;
  }
}
.action-button {
  margin: var(--spacer-xl) 0;
}
.aside {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0 var(--spacer-xl) 0;
  &__heading {
    --heading-title-color: var(--c-primary);
    margin: 0 0 var(--spacer-sm) 0;
  }
}

.slider {
  margin-bottom: 20px;
}
</style>
